import React from 'react';
import { TouchableOpacity, StyleSheet } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import theme from '../../theme';

interface BackButtonProps {
  onPress: () => void;
  color?: string;
  size?: number;
  style?: any;
}

export const BackButton = ({ 
  onPress, 
  color = theme.colors.primary, 
  size = 24,
  style 
}: BackButtonProps) => {
  return (
    <TouchableOpacity
      style={[styles.backButton, style]}
      onPress={onPress}
    >
      <Ionicons name="arrow-back" size={size} color={color} />
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  backButton: {
    padding: theme.spacing.sm,
    borderRadius: theme.borderRadius.md,
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
  },
});